import { Button, Card, ConfirmModal, Loader, Typography } from 'src/components/common';
import {
  demoDayRocket,
  ventureverselightning,
  usernew,
  flashicon,
  briefcase,
  venturechat,
  ideabulb,
  downloadIconNew,
  editIconNew
} from 'src/assets/images';
import Htraction from 'src/assets/images/logo/htraction.png';
import Ideahub from 'src/assets/images/logo/ideahub.png';
import cx from './banner.module.scss';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { TCreateMVPRequest } from 'src/services/apiEndpoint.types.ts/ideaHub/createIdea.endpoint.types';
import { createMVP } from 'src/store/ideaHub/createMVP.thunk';
import { useGetIdentity } from 'src/hooks';
import { TIdea } from 'src/components/ideaHub/ideaHub.types';
import Header from 'src/assets/images/logo/header.png';
import jsPDF from 'jspdf';
import MarkdownIt from 'markdown-it';
import { formatDate } from 'src/utils';

function IdeaHubBanner({ isView = false, viewIdea = null }: { isView?: boolean, viewIdea?: any }) {
  // hooks 
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { getIdentities } = useGetIdentity();
  const { loggedInUserType } = getIdentities();
  const { myVenture, counters, loading } = useAppSelector(
    (store) => store.venture
  );
  const isAuthorized: boolean = useAppSelector((store) => store.auth.isAuthorized);
  const { profile } = useAppSelector((store) => store.profile);
  const { myCompany } = useAppSelector((store) => store.company);
  const email = loggedInUserType === 'User' ? profile?.email : myCompany?.email;
  const userType = loggedInUserType;

  // state 
  const [show, setShow] = useState<boolean>(false);

  const handleCreate = () => {
    // if (!isAuthorized) {
    //   setShow(true);
    //   return;
    // }
  };

  function handleNavigate() {
    navigate(`/login?prev=${encodeURIComponent('/idea-hub')}`);
  }
  async function convertToMarkdown(data) {
    const markdownSections = {
      overallFeedback: "### 1. Overall Feedback",
      marketFeasibility: "### 2. Market Feasibility",
      idealCustomerAndProfile: "### 3. Ideal Customer and Profile",
      competitiveAnalysis: "### 4. Competitive Analysis",
      marketSizeAndGrowthPotential: "### 5. Market Size and Growth Potential",
      goToMarketStrategy: "### 6. Go-To-Market Strategy",
      risksAndMitigationStrategies: "### 7. Risks and Mitigation Strategies",
      financialViability: "### 8. Financial Viability",
      oneHighValueRecommendation: "### 9. One High-Value Recommendation"
    };

    const sanitizeMarkdown = (text) => {
      return text
        // First fix the colon-dash pattern with line breaks
        .replace(/:\s*\n\s*-\s*/g, ': - ')
        // Then fix colons followed by line breaks (not dashes)
        .replace(/:\s*\n(?!\s*-)/g, ': ')
        // Fix dashes preceded by line breaks (not colons)
        .replace(/(?<!:\s*)\n\s*-\s*/g, ' - ')
        // Remove any remaining line breaks after colons
        .replace(/:\s*\n/g, ': ')
        // Remove any remaining line breaks after dashes
        .replace(/-\s*\n/g, ' - ')
        // Normalize multiple spaces
        .replace(/[ ]{2,}/g, ' ')
        // Normalize line breaks
        .replace(/\n{3,}/g, '\n\n')
        .trim();
    };

    let markdown = "";
    for (const [key, title] of Object.entries(markdownSections)) {
      if (data[key]) {
        markdown += `${title}\n\n${sanitizeMarkdown(data[key])}\n\n`;
      }
    }

    return markdown.trim();
  }
  const exportReportToPDF = async (report) => {
    // Create loading spinner
    const loader = document.createElement('div');
    loader.id = 'pdfLoader';
    Object.assign(loader.style, {
      position: 'fixed',
      top: '0',
      left: '0',
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: '1000'
    });
    loader.innerHTML = `...`; // Keep your existing loader HTML
    document.body.appendChild(loader);

    try {
      async function parseJsonString(input) {
        try {
          const parsed = JSON.parse(input);
          return parsed;
        } catch (error) {
          console.error("Failed to parse JSON string:", error);
          return null;
        }
      }

      // Usage
      const a = "{\"overallFeedback\":\"**Overall Evaluation**: Your cybersecurity startup idea is well-positioned...<truncated for brevity>...\"}";
      // const parsedJson = await parseJsonString(report.validationReport);
      //     const jsonToMarkdownReport = await convertToMarkdown(parsedJson);
      //     console.log('Converted Markdown Report:', jsonToMarkdownReport);

      // const parseJsonString = async (input) => {
      //   try {
      //     return JSON.parse(input);
      //   } catch (error) {
      //     console.error("Failed to parse JSON string:", error);
      //     return null;
      //   }
      // };

      const cleanReportText = (report) => {
        for (const key in report) {
          if (typeof report[key] === 'string') {
            report[key] = report[key]
              .replace(/:\s*\n/g, ': ')
              .replace(/\n{3,}/g, '\n\n')
              .replace(/[ ]{2,}/g, ' ');
          }
        }
        return report;
      };

      const parsedJson = await parseJsonString(report);
      if (!parsedJson) throw new Error("Invalid JSON report data");

      cleanReportText(parsedJson);
      const jsonToMarkdownReport = await convertToMarkdown(parsedJson);
      const sanitizeField = (val) => {
        if (!val) return '';

        return val.trim()
          .replace(/:\s*-\s*\n/g, ': - ')
          .replace(/:\s*\n(?!\s*-)/g, ': ')
          .replace(/(?<!:\s*)-\s*\n/g, ' - ')
          .replace(/\n(?=\s*[-•*]\s)/g, ' ')
          .replace(/\n(?=\s*[:-])/g, ' ')
          .replace(/\n(?=\s*[a-zA-Z0-9])/g, ' ')
          .replace(/:\s+-\s+/g, ': - ')
          .replace(/\n{3,}/g, '\n\n')
          .replace(/[ ]{2,}/g, ' ')
          .trim();
      };
      const ideaDetails = `### Idea details
**Title:** ${sanitizeField(viewIdea?.idea.title)}  
**Domain:** ${sanitizeField(viewIdea?.idea.domain)}  
**Identified Problem:** ${sanitizeField(viewIdea?.idea.identifiedProblem)}  
**Solution Effectiveness:** ${sanitizeField(viewIdea?.idea.solutionEffectiveness)}  
**Unique Value Proposition:** ${sanitizeField(viewIdea?.idea.uniqueValueProposition)}  
**Major Revenue Stream:** ${sanitizeField(viewIdea?.idea.majorRevenueStream)}  
**Competitors:** ${sanitizeField(viewIdea?.idea.competitors)}  
**Target Audience:** ${sanitizeField(viewIdea?.idea.targetAudience)}
`;

      const markdownContent = `${ideaDetails}\n---\n${jsonToMarkdownReport}`
        .replace(/\n{3,}/g, '\n\n')
        .replace(/[ ]{2,}/g, ' ')
        .trim();
      // eslint-disable-next-line new-cap
      const doc = new jsPDF();
      const mdParser = new MarkdownIt();

      // Page dimensions and constants
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const marginTop = 30; // Increased top margin to leave space for header
      const marginBottom = 30; // Increased bottom margin to leave space for footer
      const marginLeft = 20;
      const marginRight = 20;
      const lineHeight = 7;
      let yPos = marginTop;

      // Check if we need a new page before adding content
      const checkPageBreak = (requiredHeight = lineHeight): void => {
        if (yPos + requiredHeight > pageHeight - marginBottom) {
          addFooter();
          doc.addPage();
          yPos = marginTop; // Reset Y position after page break
          addHeader();
        }
      };

      // const addFormattedText = (text: string, options: TextOptions = {}): void => {
      //   const { fontSize = 12, fontStyle = 'normal', fontWeight = 'normal', color = [0, 0, 0], align = 'left', indent = 0 } = options;
      //   doc.setFontSize(fontSize);

      //   // Apply correct font style and weight
      //   if (fontWeight === 'bold' && fontStyle === 'italic') {
      //     doc.setFont('helvetica', 'bolditalic');
      //   } else if (fontWeight === 'bold') {
      //     doc.setFont('helvetica', 'bold');
      //   } else if (fontStyle === 'italic') {
      //     doc.setFont('helvetica', 'italic');
      //   } else {
      //     doc.setFont('helvetica', 'normal');
      //   }

      //   doc.setTextColor(...color);
      //   const maxWidth = pageWidth - marginLeft - marginRight - indent;
      //   const lines = doc.splitTextToSize(text, maxWidth);

      //   lines.forEach((line) => {
      //     checkPageBreak(); // Check before each line
      //     doc.text(line, marginLeft + indent, yPos, { align });
      //     yPos += lineHeight;
      //   });
      // };

      // Add this interface at the top of your file or in a types file
      interface TextOptions {
        fontSize?: number;
        fontStyle?: 'normal' | 'italic';
        fontWeight?: 'normal' | 'bold';
        color?: [number, number, number];
        align?: 'left' | 'center' | 'right';
        indent?: number;
      }

      // Updated addFormattedText function with proper TypeScript types
      const addFormattedText = (text: string, options: TextOptions = {}): void => {
        const { fontSize = 12, fontStyle = 'normal', fontWeight = 'normal', color = [0, 0, 0], align = 'left', indent = 0 } = options;
        doc.setFontSize(fontSize);

        // Apply correct font style and weight
        if (fontWeight === 'bold' && fontStyle === 'italic') {
          doc.setFont('helvetica', 'bolditalic');
        } else if (fontWeight === 'bold') {
          doc.setFont('helvetica', 'bold');
        } else if (fontStyle === 'italic') {
          doc.setFont('helvetica', 'italic');
        } else {
          doc.setFont('helvetica', 'normal');
        }

        doc.setTextColor(color[0], color[1], color[2]);
        const maxWidth = pageWidth - marginLeft - marginRight - indent;

        // Custom text splitting that keeps colons and dashes with their preceding words
        const smartSplitText = (text: string, maxWidth: number): string[] => {
          const words = text.split(' ');
          const lines: string[] = [];
          let currentLine = '';

          for (let i = 0; i < words.length; i++) {
            const word = words[i];
            const testLine = currentLine + (currentLine ? ' ' : '') + word;
            const testWidth = doc.getStringUnitWidth(testLine) * fontSize / 72 * 25.4;

            if (testWidth <= maxWidth) {
              currentLine = testLine;
            } else {
              // Before starting a new line, check if current word ends with : or : -
              if (currentLine && (word.match(/^[:-]/) || word.match(/^-/))) {
                // If the word starts with : or -, try to keep it with the previous word
                const lastSpaceIndex = currentLine.lastIndexOf(' ');
                if (lastSpaceIndex !== -1) {
                  const lastWord = currentLine.substring(lastSpaceIndex + 1);
                  const remainingLine = currentLine.substring(0, lastSpaceIndex);
                  const combinedWord = lastWord + ' ' + word;
                  const combinedWidth = doc.getStringUnitWidth(combinedWord) * fontSize / 72 * 25.4;

                  // If the combined word fits on the next line, move both
                  if (combinedWidth <= maxWidth) {
                    if (remainingLine) {
                      lines.push(remainingLine);
                    }
                    currentLine = combinedWord;
                    continue;
                  }
                }
              }

              // Check if current word contains : or : - pattern
              if (word.includes(':')) {
                // Split the word at colon but keep colon with preceding part
                const colonIndex = word.indexOf(':');
                const beforeColon = word.substring(0, colonIndex + 1);
                const afterColon = word.substring(colonIndex + 1);

                const testWithColon = currentLine + (currentLine ? ' ' : '') + beforeColon;
                const testColonWidth = doc.getStringUnitWidth(testWithColon) * fontSize / 72 * 25.4;

                if (testColonWidth <= maxWidth) {
                  currentLine = testWithColon;
                  if (afterColon) {
                    // Add the part after colon to next iteration
                    words.splice(i + 1, 0, afterColon);
                  }
                  continue;
                }
              }

              // Standard behavior: push current line and start new one
              if (currentLine) {
                lines.push(currentLine);
              }
              currentLine = word;
            }
          }

          if (currentLine) {
            lines.push(currentLine);
          }

          return lines;
        };

        const lines = smartSplitText(text, maxWidth);

        lines.forEach((line) => {
          checkPageBreak(); // Check before each line
          doc.text(line, marginLeft + indent, yPos, { align });
          yPos += lineHeight;
        });
      };

      const addFooter = (): void => {
        const footerY = pageHeight - marginBottom / 2;
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0);
        doc.textWithLink('www.htraction.com', pageWidth / 2, footerY, {
          align: 'center',
          url: 'https://www.htraction.com'
        });
      };

      const addHeader = (): void => {
        const logoWidth = 11;
        const logoHeight = 11;
        // Place the header at the top of the page with proper margins
        doc.addImage(Header, 'PNG', pageWidth - marginRight - logoWidth, marginTop / 2, logoWidth, logoHeight);
        // Reset font styles after adding header
        doc.setFontSize(12);
        doc.setFont('helvetica', 'normal');
      };

      const createCoverPage = (): void => {
        addHeader();
        // Start content after header with appropriate spacing
        yPos = marginTop + 20;

        doc.setFillColor(250, 70, 22);
        doc.rect(marginLeft, yPos, pageWidth - marginLeft - marginRight, 15, 'F');
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(14);
        doc.setTextColor(255, 255, 255);
        doc.text('Idea Validation Report', pageWidth / 2, yPos + 12, { align: 'center' });

        yPos += 30; // Move down for next element

        // Handle idea title with potential wrapping
        doc.setFillColor(250, 70, 22);
        const titleText = `Idea Title - ${viewIdea?.idea.title}`;
        doc.setFontSize(12);

        // Calculate how much space the text will need
        const titleWidth = pageWidth - marginLeft - marginRight - 20; // Adding some padding
        const titleSplitText = doc.splitTextToSize(titleText, titleWidth);
        const titleHeight = titleSplitText.length * 7; // Approximately 7 points per line

        // Create rectangle that can expand based on text height
        doc.rect(marginLeft, yPos, pageWidth - marginLeft - marginRight, titleHeight + 6, 'F');

        // Center the text vertically inside the rectangle
        doc.setTextColor(255, 255, 255);
        const textYPos = yPos + 6; // Initial position
        for (let i = 0; i < titleSplitText.length; i++) {
          doc.text(titleSplitText[i], pageWidth / 2, textYPos + (i * 7), { align: 'center' });
        }

        yPos += titleHeight + 16; // Move down past the title rectangle with some extra space

        // Continue with logos
        const image1Width = 70;
        const image1Height = 20;
        const image2Width = 38;
        const image2Height = 20;
        doc.addImage(Htraction, 'PNG', marginLeft + 20, yPos, image1Width, image1Height);
        doc.addImage(Ideahub, 'PNG', marginLeft + 105, yPos, image2Width, image2Height);

        yPos += 40; // Move down for taglines
        doc.setFontSize(14);
        doc.setTextColor(0, 0, 0);
        doc.text('The world needs entrepreneurs', pageWidth / 2, yPos, { align: 'center' });
        yPos += 10;
        doc.text('Be one.', pageWidth / 2, yPos, { align: 'center' });

        addFooter();
      };

      const processMarkdownContent = (markdown: string): void => {
        const sections = markdown.split('---');
        sections.forEach((section, sectionIndex) => {
          if (sectionIndex > 0) {
            checkPageBreak(lineHeight * 2); // Check before adding section divider
            doc.setDrawColor(200, 200, 200);
            doc.line(marginLeft, yPos, pageWidth - marginRight, yPos);
            yPos += lineHeight * 2;
          }

          // Parse the entire section at once
          const tokens = mdParser.parse(section, {});

          // Recursively process tokens
          const processTokens = (tokens, startIndex = 0, endIndex = tokens.length, nestLevel = 0) => {
            for (let i = startIndex; i < endIndex; i++) {
              const token = tokens[i];

              if (token.type === 'heading_open') {
                // Process heading
                const level = parseInt(token.tag.substring(1), 10);
                const contentToken = tokens[i + 1];
                i += 2; // Skip the heading content and close tokens

                if (contentToken && contentToken.type === 'inline') {
                  checkPageBreak(lineHeight * 2); // Check before adding heading
                  addFormattedText(contentToken.content, {
                    fontSize: 16 + (3 - level) * 2,
                    fontWeight: 'bold'
                  });
                  // Reduced spacing after heading - removed the 0.5 lineHeight addition
                }
              } else if (token.type === 'paragraph_open') {
                // Process paragraph and its children
                const contentIndex = i + 1;
                let closeIndex = contentIndex;

                // Find the closing tag
                while (closeIndex < endIndex && tokens[closeIndex].type !== 'paragraph_close') {
                  closeIndex++;
                }

                // If we have inline content
                if (contentIndex < closeIndex && tokens[contentIndex].type === 'inline') {
                  const inlineToken = tokens[contentIndex];
                  let paragraphText = '';
                  const formatting = [];

                  // Process inline children (bold, italic, etc.)
                  if (inlineToken.children && inlineToken.children.length > 0) {
                    for (let j = 0; j < inlineToken.children.length; j++) {
                      const child = inlineToken.children[j];

                      if (child.type === 'text') {
                        paragraphText += child.content;
                      } else if (child.type === 'strong_open') {
                        const startPos = paragraphText.length;
                        // Find the content within strong tags
                        while (j + 1 < inlineToken.children.length && inlineToken.children[j + 1].type !== 'strong_close') {
                          j++;
                          if (inlineToken.children[j].type === 'text') {
                            paragraphText += inlineToken.children[j].content;
                          }
                        }
                        j++; // Skip the strong_close tag
                        formatting.push({
                          start: startPos,
                          end: paragraphText.length,
                          style: 'bold'
                        });
                      } else if (child.type === 'em_open') {
                        const startPos = paragraphText.length;
                        // Find the content within em tags
                        while (j + 1 < inlineToken.children.length && inlineToken.children[j + 1].type !== 'em_close') {
                          j++;
                          if (inlineToken.children[j].type === 'text') {
                            paragraphText += inlineToken.children[j].content;
                          }
                        }
                        j++; // Skip the em_close tag
                        formatting.push({
                          start: startPos,
                          end: paragraphText.length,
                          style: 'italic'
                        });
                      }
                    }
                  } else {
                    // Simple paragraph with no formatting
                    paragraphText = inlineToken.content;
                  }

                  // If there's no special formatting, add the text directly
                  if (formatting.length === 0) {
                    addFormattedText(paragraphText, { fontSize: 12 });
                  } else {
                    // Handle formatted text by breaking it into segments
                    let lastEnd = 0;
                    const sortedFormatting = formatting.sort((a, b) => a.start - b.start);

                    for (const format of sortedFormatting) {
                      // Add any unformatted text before this format
                      if (format.start > lastEnd) {
                        addFormattedText(paragraphText.substring(lastEnd, format.start), { fontSize: 12 });
                      }

                      // Add the formatted text
                      const options: TextOptions = { fontSize: 12 };
                      if (format.style === 'bold') {
                        options.fontWeight = 'bold';
                      } else if (format.style === 'italic') {
                        options.fontStyle = 'italic';
                      }

                      addFormattedText(paragraphText.substring(format.start, format.end), options);
                      lastEnd = format.end;
                    }

                    // Add any remaining unformatted text
                    if (lastEnd < paragraphText.length) {
                      addFormattedText(paragraphText.substring(lastEnd), { fontSize: 12 });
                    }
                  }

                  // Add slightly less space after paragraphs
                  yPos += lineHeight * 0.3;
                }

                // Skip to after paragraph close
                i = closeIndex;
              } else if (token.type === 'bullet_list_open') {
                // Process bullet list
                let listIndex = i + 1;

                while (listIndex < endIndex && tokens[listIndex].type !== 'bullet_list_close') {
                  if (tokens[listIndex].type === 'list_item_open') {
                    // Find the content within this list item
                    let contentIdx = listIndex + 1;
                    while (contentIdx < endIndex &&
                      tokens[contentIdx].type !== 'paragraph_open' &&
                      tokens[contentIdx].type !== 'inline') {
                      contentIdx++;
                    }

                    // If we found content
                    if (contentIdx < endIndex) {
                      if (tokens[contentIdx].type === 'paragraph_open') {
                        // Skip to inline content
                        contentIdx++;
                      }

                      if (contentIdx < endIndex && tokens[contentIdx].type === 'inline') {
                        const inlineToken = tokens[contentIdx];

                        // Combine all text and formatting into a single string
                        let combinedContent = '';
                        const formattingRanges = [];

                        // Process inline children to build combined content
                        if (inlineToken.children && inlineToken.children.length > 0) {
                          for (let j = 0; j < inlineToken.children.length; j++) {
                            const child = inlineToken.children[j];

                            if (child.type === 'text') {
                              combinedContent += child.content;
                            } else if (child.type === 'strong_open') {
                              const startPos = combinedContent.length;
                              let boldContent = '';

                              // Find the content within strong tags
                              while (j + 1 < inlineToken.children.length && inlineToken.children[j + 1].type !== 'strong_close') {
                                j++;
                                if (inlineToken.children[j].type === 'text') {
                                  boldContent += inlineToken.children[j].content;
                                }
                              }

                              combinedContent += boldContent;
                              j++; // Skip the strong_close

                              formattingRanges.push({
                                start: startPos,
                                end: combinedContent.length,
                                style: 'bold'
                              });
                            } else if (child.type === 'em_open') {
                              const startPos = combinedContent.length;
                              let italicContent = '';

                              // Find the content within em tags
                              while (j + 1 < inlineToken.children.length && inlineToken.children[j + 1].type !== 'em_close') {
                                j++;
                                if (inlineToken.children[j].type === 'text') {
                                  italicContent += inlineToken.children[j].content;
                                }
                              }

                              combinedContent += italicContent;
                              j++; // Skip the em_close

                              formattingRanges.push({
                                start: startPos,
                                end: combinedContent.length,
                                style: 'italic'
                              });
                            }
                          }
                        } else {
                          // Simple text with no formatting
                          combinedContent = inlineToken.content;
                        }

                        // Check if we have space for at least one line of the bullet
                        checkPageBreak();

                        // Add bullet at current position
                        const bulletStartY = yPos;
                        doc.setFont('helvetica', 'normal');
                        doc.setFontSize(12);
                        doc.text('• ', marginLeft + 10, yPos);

                        // Prepare the content
                        const indentation = 10;
                        const bulletWidth = doc.getStringUnitWidth('• ') * 12 / 72 * 25.4;
                        const textStartX = marginLeft + 10 + bulletWidth;
                        const availableWidth = pageWidth - marginRight - textStartX;

                        // If no special formatting, use the text wrapping function
                        if (formattingRanges.length === 0) {
                          // Split text to fit within available width
                          const lines = doc.splitTextToSize(combinedContent, availableWidth);

                          // First line goes next to bullet
                          if (lines.length > 0) {
                            checkPageBreak();
                            doc.text(lines[0], textStartX, bulletStartY);
                          }

                          // Subsequent lines go below with indentation
                          for (let lineIdx = 1; lineIdx < lines.length; lineIdx++) {
                            checkPageBreak();
                            yPos += lineHeight;
                            doc.text(lines[lineIdx], textStartX, yPos);
                          }
                        } else {
                          // For formatted text, we need to handle it segment by segment
                          // Sort formatting ranges
                          const sortedRanges = formattingRanges.sort((a, b) => a.start - b.start);

                          // Current position tracking
                          let lineStartY = bulletStartY;
                          let currentX = textStartX;
                          let lastEnd = 0;

                          // Process each segment
                          for (let rangeIdx = 0; rangeIdx <= sortedRanges.length; rangeIdx++) {
                            let segment;
                            let segmentStyle = 'normal';

                            if (rangeIdx < sortedRanges.length) {
                              const range = sortedRanges[rangeIdx];

                              // Add any text before this range
                              if (range.start > lastEnd) {
                                segment = combinedContent.substring(lastEnd, range.start);
                                segmentStyle = 'normal';
                              } else {
                                segment = combinedContent.substring(range.start, range.end);
                                segmentStyle = range.style;
                              }

                              lastEnd = range.end;
                            } else if (lastEnd < combinedContent.length) {
                              // Add any remaining text after all ranges
                              segment = combinedContent.substring(lastEnd);
                              segmentStyle = 'normal';
                            } else {
                              break; // No more text to process
                            }

                            if (!segment || segment.length === 0) continue;

                            // Set appropriate font style
                            if (segmentStyle === 'bold') {
                              doc.setFont('helvetica', 'bold');
                            } else if (segmentStyle === 'italic') {
                              doc.setFont('helvetica', 'italic');
                            } else {
                              doc.setFont('helvetica', 'normal');
                            }

                            // Split segment to fit available width
                            const segmentWidth = doc.getStringUnitWidth(segment) * 12 / 72 * 25.4;

                            // Check if the segment fits on the current line
                            if (currentX + segmentWidth > pageWidth - marginRight) {
                              // Start a new line with proper indentation
                              checkPageBreak();
                              yPos += lineHeight;
                              lineStartY = yPos;
                              currentX = textStartX;
                            }

                            // Measure each word to handle wrapping within segments
                            const words = segment.split(' ');
                            let currentWordIndex = 0;

                            while (currentWordIndex < words.length) {
                              const currentLineWords = [];
                              let lineWidth = 0;

                              // Build up a line of text that fits within available width
                              while (currentWordIndex < words.length) {
                                const word = words[currentWordIndex];
                                const wordWidth = doc.getStringUnitWidth(word + ' ') * 12 / 72 * 25.4;

                                if (currentX + lineWidth + wordWidth <= pageWidth - marginRight) {
                                  currentLineWords.push(word);
                                  lineWidth += wordWidth;
                                  currentWordIndex++;
                                } else {
                                  break; // Line is full
                                }
                              }

                              // If we have words for this line, render them
                              if (currentLineWords.length > 0) {
                                const lineText = currentLineWords.join(' ');
                                doc.text(lineText, currentX, lineStartY);

                                // Update position for next segment
                                currentX += doc.getStringUnitWidth(lineText + ' ') * 12 / 72 * 25.4;

                                // If there are more words, start a new line
                                if (currentWordIndex < words.length) {
                                  checkPageBreak();
                                  yPos += lineHeight;
                                  lineStartY = yPos;
                                  currentX = textStartX;
                                }
                              } else {
                                // This handles the case where a single word is too long for the line
                                // We have to split it character by character
                                const word = words[currentWordIndex];
                                let charIndex = 0;
                                let currentChars = '';

                                while (charIndex < word.length) {
                                  const nextChar = word[charIndex];
                                  const charWidth = doc.getStringUnitWidth(nextChar) * 12 / 72 * 25.4;

                                  if (currentX + doc.getStringUnitWidth(currentChars + nextChar) * 12 / 72 * 25.4 <= pageWidth - marginRight) {
                                    currentChars += nextChar;
                                    charIndex++;
                                  } else {
                                    // Render current chars and move to next line
                                    if (currentChars.length > 0) {
                                      doc.text(currentChars, currentX, lineStartY);
                                    }

                                    checkPageBreak();
                                    yPos += lineHeight;
                                    lineStartY = yPos;
                                    currentX = textStartX;
                                    currentChars = '';
                                  }
                                }

                                // Render any remaining chars
                                if (currentChars.length > 0) {
                                  doc.text(currentChars, currentX, lineStartY);
                                  currentX += doc.getStringUnitWidth(currentChars + ' ') * 12 / 72 * 25.4;
                                }

                                currentWordIndex++;
                              }
                            }
                          }
                        }

                        // Move to next line after bullet point is complete
                        yPos += lineHeight;
                      }
                    }
                  }

                  // Move to the next token
                  listIndex++;
                }

                // Skip to after bullet_list_close
                i = listIndex;
                yPos += lineHeight * 0.5;
              } else if (token.type === 'hr') {
                // Horizontal rule
                checkPageBreak();
                doc.setDrawColor(200, 200, 200);
                doc.line(marginLeft, yPos, pageWidth - marginRight, yPos);
                yPos += lineHeight;
              }
            }
          };

          // Process the entire section
          processTokens(tokens);
        });
      };

      createCoverPage();
      doc.addPage();
      yPos = marginTop; // Set Y position to start after header
      addHeader();
      //     const markdownContent = `### Idea details
      // **Title:** ${idea.title.trim()}  
      // **Domain:** ${idea.domain.trim()}  
      // **Identified Problem:** ${idea.identifiedProblem.trim()}  
      // **Solution Effectiveness:** ${idea.solutionEffectiveness.trim()}  
      // **Unique Value Proposition:** ${idea.uniqueValueProposition.trim()}  
      // **Major Revenue Stream:** ${idea.majorRevenueStream.trim()}  
      // **Competitors:** ${idea.competitors.trim()}  
      // **Target Audience:** ${idea.targetAudience.trim()}
      // ---
      // ${jsonToMarkdownReport}`;
      processMarkdownContent(markdownContent);
      addFooter();
      doc.save(`Validation Report - ${viewIdea?.idea.title}.pdf`);
    } catch (error) {
      console.error('Error generating PDF:', error);
    } finally {
      document.body.removeChild(loader);
    }
  };
  function handleUpdate () {
    navigate(`/idea-hub?id=${viewIdea?.idea?.id}`)
  }
  const isInAppropriate = viewIdea?.idea?.validationReport?.includes('Please provide appropriate input to generate an actionable report.')

  return (
    <>
      <div className="row g-3 h-auto">
        <div className="col-12">
          <div className={cx.BannerOuter}>
            <div className={cx.left}>
              <h3>{viewIdea?.idea?.title || "Validate Your Idea with AI"}</h3>
              {!viewIdea && <p>
                Step into the Venture Verse & explore a dynamic universe of startups, from{' '}
                <strong>ideas to scaling ventures.</strong>
              </p>}
              {viewIdea?.idea?.domain && <p style={{ marginBottom: '2px' }} >
                {viewIdea?.idea?.domain}
              </p>}
              {viewIdea?.idea?.createdAt && <p>
                {formatDate({ dateString: viewIdea?.idea?.createdAt })}
              </p>}
              <div className={cx.buttonsContainer}>
                {isView && viewIdea && (
                  <div className={cx.buttonInner}>
                    {!isInAppropriate && <button type="button" aria-label="Download PDF" onClick={() => exportReportToPDF(viewIdea?.idea?.validationReport)}>
                      <img src={downloadIconNew} alt="download icon" />
                      Download PDF
                    </button>}
                    <button type="button" aria-label="Update and Validate Idea" onClick={handleUpdate} >
                      <img src={editIconNew} alt="" />
                      Update & Validate Idea
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className={cx.right}>
              <img src={ideabulb} alt="Light bulb representing idea validation" />
            </div>
          </div>
        </div>
      </div >

      <ConfirmModal
        title=""
        description={
          <div style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            margin: '0',
            textAlign: 'center'
          }}>
            <span>
              To enjoy all the features of{' '}
              <span style={{ color: '#fa4616' }}>htraction</span>
            </span>
            <span>
              <span style={{ color: '#fa4616' }}>Sign in</span> to Continue
            </span>
          </div>
        }
        openConfirmModal={show}
        onClose={() => setShow(false)}
        onSubmit={handleNavigate}
        submitText="Sign in"
        type="confirm"
      />
    </>
  );
}

export default IdeaHubBanner;
